import React from 'react'

import { HomepageCarousel } from 'components/HomepageCarousel'
import { useCarouselSpringboardExp } from 'experiments/pen-4889_v1_hp_carousel_springboard'

import { QuizOnlyOnce } from './components/QuizOnlyOnce'
import styles from './HeroQuiz.module.scss'

export const HeroQuiz = () => {
  const { isPen4889Variant } = useCarouselSpringboardExp()

  return (
    <div className='container'>
      <div className='row no-gutters'>
        <div className='col-12 col-md-7 col-lg-6'>
          <QuizOnlyOnce />
        </div>
        <div className='d-none d-md-block d-lg-none col-md-1' />
        <div
          className={`col-12 col-md-4 col-lg-6 ${styles.carousel} ${isPen4889Variant ? styles.pen4889Variant1 : ''}`}
        >
          <HomepageCarousel />
        </div>
      </div>
    </div>
  )
}
